import React from 'react';
import { stalenessOf } from '../utils/staleness';
interface DataBadgeProps {
  mode: 'live' | 'snapshot' | 'loading';
  source: string;
  asOf?: string;
}
export function DataBadge({
  mode,
  source,
  asOf
}: DataBadgeProps) {
  const label = mode === 'live' ? 'Live' : mode === 'snapshot' ? 'Snapshot' : 'Loading';
  const dot = mode === 'live' ? 'bg-live' : mode === 'snapshot' ? 'bg-machine' : 'bg-faint motion-safe:animate-pulse';
  const stale = mode === 'snapshot' ? stalenessOf(asOf) : {
    level: 'fresh' as const,
    days: null
  };
  return <span className="inline-flex max-w-full items-center gap-2 rounded-full border border-line bg-surface px-2.5 py-1 font-mono text-[11px] text-muted" data-id="element-364" data-mp="o2o94if6q95p">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} aria-hidden="true" data-id="element-365" data-mp="e2dsentxyjls" />
      <span className="text-ink" data-id="element-366" data-mp="23idaiufjfjdk">{label}</span>
      <span className="truncate" data-id="element-367" data-mp="23imyydkxpih5">
        {source}
        {asOf ? ` · as of ${asOf}` : ''}
      </span>
      {stale.level !== 'fresh' && <span className={`shrink-0 rounded-full px-1.5 py-px text-[10px] font-medium ${stale.level === 'expired' ? 'bg-signal/15 text-signal' : 'bg-machine/15 text-machine'}`} title={`Snapshot is ${stale.days} days old`} data-id="element-368" data-mp="1jjcunsl9zuzl">
          {stale.level === 'expired' ? `stale · ${stale.days}d` : `needs refresh · ${stale.days}d`}
        </span>}
    </span>;
}